import React from 'react';
import styled from 'astroturf/react';

import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import { Body } from 'js/design_system/Body';
import { Icon } from 'js/design_system/Icon';
import { ImpressionPropsGenerator } from 'js/social/ImpressionHelper';
import { useCurrentUserAsFollowableUser } from '../CreateSocialItem/useCurrentUserAsFollowableUser';
import { AuthorHeader } from '../News/AuthorHeader';
import _Wrapper from "SidebarAddComment-Wrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/Sidebar/SidebarAddComment.tsx?styleId=Wrapper";
import _StartCommentPromptWrapper from "SidebarAddComment-StartCommentPromptWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/Sidebar/SidebarAddComment.tsx?styleId=StartCommentPromptWrapper";
import _StartCommentPrompt from "SidebarAddComment-StartCommentPrompt.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/Sidebar/SidebarAddComment.tsx?styleId=StartCommentPrompt";
import _PublicNotice from "SidebarAddComment-PublicNotice.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/Sidebar/SidebarAddComment.tsx?styleId=PublicNotice";
import _PublicText from "SidebarAddComment-PublicText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/Sidebar/SidebarAddComment.tsx?styleId=PublicText";


const Wrapper = /*#__PURE__*/styled("div", null, {
  displayName: "Wrapper",
  styles: _Wrapper
});

const StartCommentPromptWrapper = /*#__PURE__*/styled(ImpressionWatcher, null, {
  displayName: "StartCommentPromptWrapper",
  styles: _StartCommentPromptWrapper
});

const StartCommentPrompt = /*#__PURE__*/styled("button", null, {
  displayName: "StartCommentPrompt",
  styles: _StartCommentPrompt
});

const PublicNotice = /*#__PURE__*/styled("div", null, {
  displayName: "PublicNotice",
  styles: _PublicNotice
});

const PublicText = /*#__PURE__*/styled(Body, null, {
  displayName: "PublicText",
  styles: _PublicText
});

interface SidebarAddCommentProps {
  background?: 'white' | 'gray';
  onStartComment(): void;
  impressionPropsGen: ImpressionPropsGenerator;
}

const SidebarAddComment = ({
  background = 'white',
  onStartComment,
  impressionPropsGen,
}: SidebarAddCommentProps) => {
  const author = useCurrentUserAsFollowableUser();

  if (!author) {
    return null;
  }

  return (
    <Wrapper background={background}>
      <Body size="md" bold>
        Add your comments
      </Body>
      <AuthorHeader
        kind="user"
        user={author}
        size="sm"
        showAvatar={true}
        showTimestamp={false}
        impressionPropsGen={impressionPropsGen}
      />
      <StartCommentPromptWrapper
        {...impressionPropsGen()()('sidebar-add-comment')}
      >
        <StartCommentPrompt onClick={onStartComment}>
          <Body size="md">Add your comments...</Body>
        </StartCommentPrompt>
      </StartCommentPromptWrapper>
      <PublicNotice>
        <Icon name="public" />
        <PublicText size="sm">Public to all researchers</PublicText>
      </PublicNotice>
    </Wrapper>
  );
};

export default SidebarAddComment;
